import React, { useState } from 'react';
import TableWithHeader from '../../../components/TableWithHeader';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { type RootState } from '../../../redux/store';
import Modal from '../../../components/Modal';
import NetworkForm from '../NetworkForm';
import { useStation } from '../../../redux/reducers/stations';
import t from '../../../lib/translate';
import { type StationNetworkConfig } from 'src/types';
import { deleteStationNetworkConfig } from '../../../redux/actions/stationNetworkConfigs';

const Networks = (): React.ReactElement => {
  const dispatch = useAppDispatch();

  const networks = useAppSelector(
    (state: RootState) => state.station.networkConfigs.networkConfigs
  );
  const stations = useAppSelector((state) => state.stations);
  const { stationId } = useStation(stations);

  const [tableOpen, toggleTable] = useState(true);
  const [modalOpen, toggleModal] = useState(false);

  const handleDelete = (config: StationNetworkConfig) => {
    if (window.confirm(t('station.delete.network.config.confirm', config.alias))) {
      void dispatch(deleteStationNetworkConfig(config));
    }
  };

  return (
    <div className='networks'>
      <Modal open={modalOpen}>
        <NetworkForm
          stationId={stationId}
          finished={() => {
            toggleModal(false);
          }}
        />
      </Modal>
      <TableWithHeader
        name='stationNetworks'
        open={tableOpen}
        columnNames={['label', 'alias', 'source']}
        rowData={networks}
        toggleOpenTable={() => {
          toggleTable(!tableOpen);
        }}
        toggleModalOpen={() => {
          toggleModal(!modalOpen);
        }}
        deleteRow={(e) => {
          handleDelete(e);
        }}
      />
    </div>
  );
};

export default Networks;
